import { createContext } from "react";

import { RoutesContextState } from "./types";

const RoutesContext = createContext({} as RoutesContextState);

export default RoutesContext;
